module.exports = __webpack_public_path__ + "img/zhanghuxiugai.6db60995.png";